export const ROLE_DISPLAY_LABELS = {
  employee: 'UI1 · Member',
  floor_leader: 'UI1 · Member',
  team_manager: 'UI1 · Member',
  top_manager: 'UI1 · Member',
  admin: 'UI2 · Tenant Admin',
  master_admin: 'UI3 · Platform owner',
};

export const ROLE_LEVEL_OPTIONS = [
  { value: 'employee', label: 'UI1 · Member' },
  { value: 'admin', label: 'UI2 · Tenant Admin' },
];

// Old middle levels read as Members; their abilities live on as ticks.
export const normalizeRoleLevel = (role) => (role === 'admin' ? 'admin' : 'employee');

export const getRoleLabel = (role, user = {}) => {
  if (role === 'master_admin' || user?.is_master_admin) {
    return ROLE_DISPLAY_LABELS.master_admin;
  }

  return ROLE_DISPLAY_LABELS[role] || ROLE_DISPLAY_LABELS.employee;
};

// Plain-language access levels for people-management screens. The UI code stays
// visible as a hint because emails and permission messages still use it.
export const ACCESS_LEVEL_OPTIONS = [
  { value: 'employee', label: 'Member', code: 'UI1', description: 'Asks questions and uses shared knowledge. The Tenant Admin can tick extra abilities.' },
  { value: 'admin', label: 'Tenant Admin', code: 'UI2', description: 'Full control of this organisation.' },
];

export const accessLevelMeta = (role) =>
  ACCESS_LEVEL_OPTIONS.find((option) => option.value === normalizeRoleLevel(role)) || ACCESS_LEVEL_OPTIONS[0];
